import { Fancybox } from "@fancyapps/ui";

// Import custom components
import ResponsiveImages from "./components/ResponsiveImages";
import CookieBar from "./components/CookieBar";
import InView from "./components/InView";
import Form from "./components/Form";
import FileUpload from "./components/FileUpload";
// import MatomoTracker from "./Components/MatomoTracker";
import Header from "./components/Header";

document.addEventListener("DOMContentLoaded", () => {
    // Initialize components when the DOM is fully loaded

    // new MobileNavigation(); // Uncomment if mobile navigation is needed
    new ResponsiveImages();   // Handle responsive images
    new CookieBar();          // Display and manage cookie consent
    new InView();             // Handle elements entering the viewport
    new Form();               // Initialize form interactions
    new FileUpload();         // Initialize file upload drag & drop
    new Header();             // Initialize header interactions

    Fancybox.bind("[data-fancybox]", []);

    // Initialize Matomo link tracking
    // new MatomoTracker({
    //     // You can override default options here if needed
    //     trackExternalLinks: true,
    //     trackDownloads: true,
    //     trackMailto: true,
    //     trackTel: true
    // });
});
